<template>
  <div class="modal-content-virtual-member">
    <div class="modal-header">
      <h2>Kreiranje nove infrastrukture</h2>
    </div>
    <div class="body">
      <div id="first-section">
        <label class="col-form-label col-form-label-lg">
          Kategorija
          <span class="mandatory">*</span>
        </label>
        <model-select
          ref="municipality"
          :options="infrastructureCategories"
          v-model="infrastructureCategory"
          placeholder="
            Izaberite kategoriju"
          class="muni-dropdown add-member-dropdown"
        ></model-select>

        <label class="col-form-label col-form-label-lg">
          Naziv
          <span class="mandatory">*</span>
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite naziv"
          v-model.trim="name"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Opis
        </label>
        <input
          class="form-control"
          rows="4"
          placeholder="Unesite opis"
          v-model.trim="description"
          @focus="errorOccurred = false"
        />
        <label class="col-form-label col-form-label-lg">
          Serviseri
        </label>
        <div
          class="contacts"
          v-for="(con, index) in addedContractors"
          :key="index"
        >
          <div style="text-align: right">
            <span class="btn btn-primary" @click="removeContractor(con)">
              <i class="fas fa-minus"></i>
            </span>
          </div>
          <div class="address-wrapper">
            <div class="first-item">
              <label class="col-form-label col-form-label-lg">
                Naziv
                <span class="mandatory">*</span>
              </label>
              <model-select
                ref="municipality"
                :options="contractors"
                v-model="con.selectedContractor"
                placeholder="
            Izaberite servisera"
                class="muni-dropdown add-member-dropdown"
                @input="onContractorChange(con, index)"
              ></model-select>
            </div>
            <div class="second-item">
              <label class="col-form-label col-form-label-lg">
                Kontakt osoba
              </label>
              <model-select
                ref="municipality"
                :options="con.contacts"
                v-model="con.selectedContact"
                placeholder="
            Izaberite kontakt osobu"
                class="muni-dropdown add-member-dropdown"
              ></model-select>
            </div>
          </div>
        </div>
        <button
          class="btn btn-primary btn--mod add-new-contact"
          :disabled="loading"
          @click="addContractor"
        >
          <p>Dodaj novog servisera</p>
        </button>
        <div id="upload-area">
          <upload-button
            @files-selected="getFiles"
            ref="uploadBtn"
          ></upload-button>
          <div
            id="uploaded-files"
            :class="{ 'pointer-cursor': files.length == 0 }"
            @click="addFile"
            @dragover.prevent
            @dragleave.prevent
            @drop="onDrop"
          >
            <div class="upload-wrapper" v-if="files.length == 0">
              <svg
                class="upload-icon pointer-cursor"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="33"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <label class="upload-text pointer-cursor"
                >Izaberite datoteku</label
              >
            </div>
            <!-- <div id="empty-files" v-if="files.length == 0">
                <p>Trenutno nemate dodatih datoteka</p>
              </div>-->
            <div class="file" v-for="(file, index) of files" :key="index">
              <p>{{ file.name }}</p>
              <i
                class="fas fa-times del--mod"
                @click="removeUploadedFile(index)"
              ></i>
            </div>
            <div
              class="upload-more-wrapper pointer-cursor"
              @click="addMoreFiles"
              v-if="files.length > 0"
            >
              <svg
                class="upload-more-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <span class="upload-more-text">Dodaj datoteku</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          :disabled="loading"
          @click="submitMedia"
        >
          <p v-if="!loading">Dodaj novu infrastrukturu</p>
          <spinner :size="20" line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import debounce from 'debounce';
import { ModelSelect } from 'vue-search-select';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';

export default {
  components: {
    ModelSelect,
    uploadButton
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: '',
      loading: false,
      infrastructureCategories: [],
      infrastructureCategory: null,
      files: [],
      removingFile: false,
      contractors: [],
      addedContractors: [],
      name: '',
      description: ''
    };
  },
  async created() {
    this.infrastructureCategories = this.$store.state.modal.infrastructureCategories;
    const contractorsResult = await this.getAllContractors(false);
    this.contractors = contractorsResult.map(cat => {
      cat.value = cat;
      cat.text = cat.name;
      return {
        value: cat,
        text: cat.name
      };
    });
  },
  watch: {
    infrastructureCategory: function(data) {
      if (data.id) {
        data = {
          text: data.name,
          value: data
        };
        this.infrastructureCategory = data;
        this.name = data.name;
      } else {
        this.name = data.text;
      }
    }
  },
  methods: {
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapActions('table', ['getAllContractors', 'getAllInfrastructure']),
    async onContractorChange(contractor, index) {
      const id = contractor.selectedContractor.value.id;
      if (id) {
        const result = await axios.get(`/contractor/${id}`);
        this.addedContractors[
          index
        ].contacts = result.data.contractor.contacts.map(con => {
          return {
            text: `${con.name} (${con.phone})`,
            value: con.id
          };
        });
      }
    },
    onDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      var files = e.dataTransfer.files;
      this.files.push(...files);
    },
    addContractor() {
      this.addedContractors.push({ contacts: [] });
    },
    removeContractor(con) {
      this.addedContractors = this.addedContractors.filter(c => c != con);
    },
    addFile() {
      if (this.files.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
      return;
    },
    getFiles(load) {
      for (let l of load) {
        this.files.push(l);
      }
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.files.splice(index, 1);
    },
    submitMedia() {
      this.errorOccurred = false;

      if (!this.validateInput()) {
        this.errorOccurred = true;
        return;
      }
      this.loading = true;
      if (this.files.length == 0) {
        this.addInfrastructure();
        return;
      }
      axios
        .post('/media/add', this.formatMediaForSubmit(), {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(data => {
          this.addInfrastructure(data);
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          this.showFailModal();
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.files.length; i++) {
        fd.append('files[]', this.files[i], this.files[i].name);
      }
      fd.append('type', 'community');
      fd.append(
        'community_id',
        this.$store.getters.getActiveCommunity.community_id
      );

      return fd;
    },
    async addInfrastructure(mediaIds) {
      this.errorOccurred = false;
      let data = {
        communityId: this.$store.getters.getActiveCommunity.id,
        infrastructureType: this.infrastructureCategory.value.id,
        name: this.name,
        description: this.description,
        memberId: this.$store.getters.getActiveCommunity.member_id
      };
      if (this.addedContractors.length > 0) {
        data.contractors = this.addedContractors.map(c => {
          let contractorId = null;
          if (c.selectedContractor.id) {
            contractorId = c.selectedContractor.id;
          } else {
            contractorId = c.selectedContractor.value.id;
          }
          return {
            contractorId: contractorId,
            contractorContactId: c.selectedContact
          };
        });
      }
      if (mediaIds) {
        data.mediaIds = mediaIds.data.ids;
      }
      try {
        await axios.post('infrastructure', data);
        // await this.getAllContractors();
        this.getAllInfrastructure({
          communityId: this.$store.getters.getActiveCommunity.community_id,
          infraTypes: this.$store.state.modal.infrastructureCategories
        });
        this.loading = false;
        this.closeModal();
        this.showSuccessModal();
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.showFailModal();
      }

      //   financesInstance
      //     .post(`communities/${this.$route.params.id}/member`, virtualMemberData)
      //     .then(async () => {
      //       const virtualMembers = await this.getAllMembersForCommunityFinances(
      //         this.$route.params.id
      //       );
      //       this.setVirtualMembersList(virtualMembers);
      //       this.loading = false;
      //       this.closeModal();
      //       this.showSuccessModal();
      //     })
      //     .catch(error => {
      //       this.loading = false;
      //       console.log(error);
      //       this.showFailModal();
      //     });
    },
    validateInput() {
      if (
        !this.infrastructureCategory ||
        !this.infrastructureCategory.value ||
        !this.infrastructureCategory.value.id
      ) {
        this.errorMessage = 'Morate uneti kategoriju infrastrukture';
        return false;
      }
      if (this.name.trim() == '') {
        this.errorMessage = 'Morate uneti naziv infrastrukture';
        return false;
      }
      if (this.addedContractors.length > 0) {
        for (const contractor of this.addedContractors) {
          if (
            !contractor.selectedContractor ||
            (!contractor.selectedContractor.id &&
              !contractor.selectedContractor.value.id)
          ) {
            this.errorMessage = 'Morate izabrati naziv servisera';
            return false;
          }
        }
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
#upload-area {
  display: block;
  margin-left: 9px;
  width: 100%;
  height: 100%;
  text-align: center;
}

#uploaded-files {
  border: 1px dotted var(--primary-color);
  border-radius: 0.25rem;
  height: 110px;
  resize: none;
  max-height: 134px;
  overflow-y: auto;
  padding: 5px;
}
.file {
  border-bottom: solid 1px lightgray;
  font-size: 15px;
  width: 100%;
  display: inline-flex;
  vertical-align: center;
  p {
    text-align: left;
    word-break: break-word;
    margin-bottom: 2px;
  }
  i {
    margin-left: 4px;
  }
}
.del--mod {
  margin-left: auto;
  /*margin-right: 0;*/
  cursor: pointer;
  color: red;
  top: 4.7em;
  right: 1.7em;
}
.upload-more-wrapper {
  width: 30%;
  margin: 0 auto;
}
#empty-files {
  text-align: center;
  color: grey;
  margin-top: 15%;
}
.user--mod {
  .text {
    max-width: calc(100% - 30px) !important;
  }
}
.address-search {
  height: calc(2.25rem + 5px) !important;
  input {
    font-size: 1rem !important;
  }
  item {
    font-size: 1rem !important;
  }
}
.list-no-border {
  border: none !important;
}
.modal-content-virtual-member {
  .add-new-contact {
    margin-left: 0 !important;
    // margin-top: 16px;
  }
  .contacts {
    padding: 8px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    margin-bottom: 16px;
    span.btn-primary {
      width: 4rem;
      min-width: 25px;
    }
  }
  .address-wrapper {
    display: flex;
    .address-street {
      flex: 3;
    }
    .address-number {
      flex: 1;
      margin-left: 16px;
      input {
        height: calc(2.25rem + 5px) !important;
      }
    }
    .first-item {
      flex: 1;
    }
    .second-item {
      flex: 1;
      margin-left: 16px;
    }
  }
  .input-wrapper {
    display: flex;
    width: 100%;
    position: relative;
    .user--mod {
      width: 100%;
      z-index: 5;
      margin-bottom: 2rem;
      input {
        margin-bottom: 0;
      }
      .address-search {
        width: 100%;
        line-height: 1.5;
        border-radius: 0.3rem;
        border: 1px solid #ced4da;
        font-size: 1rem;
        color: #495057;
        transition: 0.2s all;
        height: calc(2.25rem + 2px);

        // input {
        //   border: none;
        //   padding: 0.5rem 1rem;
        //   font-size: 1rem;
        //   line-height: 1;
        //   max-width: 100%;
        // }

        input:focus {
          border: none;
          outline: none;
          & {
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .text {
          position: absolute;
          top: 7px;
          left: 1rem;
          color: #5f5f5f;
          font-size: 1rem;
        }
        .menu {
          border: 1px solid #ced4da;
          border-radius: 0.3rem;
          border-top-width: 0;
          border-top-right-radius: 0;
          border-top-left-radius: 0;
          z-index: 11;
          background-color: white;
          max-height: 10rem;
          overflow-y: auto;
          margin: -5px -1px 0px -1px;
          .item {
            z-index: 15;
          }
          .item:hover {
            background-color: rgba(0, 0, 0, 0.05);
            cursor: pointer;
          }

          .item.selected {
            background-color: rgba(0, 0, 0, 0.178);
          }

          .btn--add {
            width: 100%;
          }
        }
      }
    }
    .add-member-dropdown {
      .menu {
        max-height: 10rem !important;
      }
    }

    .amount--mod {
      width: 100%;
      margin-bottom: 2rem;
    }

    .input-span {
      position: absolute;
      font-size: 1.5rem;
      color: rgb(95, 95, 95);
      top: 0.5rem;
      pointer-events: none;
      transition: 0.2s all;
      left: 1rem;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input {
      margin-right: 15px;
    }

    .input--:focus ~ .input-span--name,
    .input--name:not(:placeholder-shown) ~ .input-span--name {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
      // opacity: 0;
    }

    .input--amount:focus ~ .input-span--amount,
    .input--amount:not(:placeholder-shown) ~ .input-span--amount {
      transform: scale(0.75) translateY(-50px) translateX(-30px);
    }

    .relative {
      position: relative;
    }
  }

  .body {
    height: 100%;
    width: 100%;
  }

  input {
    margin-bottom: 9px;
    position: relative;
  }

  .btn-add-desc {
    i {
      margin-left: 4px;
    }
  }

  .desc-wrapper {
    display: flex;
    justify-content: space-between;
    span {
      margin-bottom: 9px;
      margin-left: 8px;
      min-width: 60px;
    }
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }

  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .mandatory {
    color: red;
  }

  label.tooltip-label {
    display: flex;
    .mandatory {
      margin-left: 4px;
    }
    .popover {
      position: relative;
      width: fit-content;
      border: none;
      padding: 4px 4px 2px 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 1.1rem;
        color: var(--primary-color);
      }
    }
  }
}
</style>
